var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackberry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blackberry"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M17.9782 9.78598C17.9782 14.3566 14.2729 18.0661 9.69809 18.0661C5.12332 18.0661 1.41797 14.3566 1.41797 9.78598C1.41797 5.21121 5.12332 1.50586 9.69809 1.50586C14.2729 1.50586 17.9782 5.21121 17.9782 9.78598Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blackberry_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53114 5.05469L4.95307 7.42044H6.94072C7.47124 7.42044 7.93367 7.05103 8.06234 6.52445C8.24476 5.77788 7.69287 5.05469 6.94072 5.05469H5.53114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95307 8.60331L4.375 10.9691H6.36265C6.89317 10.9691 7.3556 10.5997 7.48427 10.0731C7.66669 9.32651 7.1148 8.60331 6.36265 8.60331H4.95307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42147 10.9691L8.99954 8.60331H10.4091C11.1613 8.60331 11.7132 9.32651 11.5307 10.0731C11.4021 10.5997 10.9396 10.9691 10.4091 10.9691H8.42147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42147 12.1519L7.84341 14.5177H9.83106C10.3616 14.5177 10.824 14.1483 10.9527 13.6217C11.1351 12.8751 10.5832 12.1519 9.83106 12.1519H8.42147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8775 13.3348H11.8899L12.4679 10.9691H13.8775C14.6297 10.9691 15.1816 11.6923 14.9992 12.4388C14.8705 12.9654 14.408 13.3348 13.8775 13.3348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.046 7.42044L12.4679 9.78619H14.4556C14.9861 9.78619 15.4486 9.41678 15.5772 8.8902C15.7596 8.14363 15.2078 7.42044 14.4556 7.42044H13.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99954 7.42044L9.57761 5.05469H10.9872C11.7393 5.05469 12.2912 5.77788 12.1088 6.52445C11.9801 7.05103 11.5177 7.42044 10.9872 7.42044H8.99954Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackberry);
export default __webpack_public_path__ + "static/media/blackberry.9468bbdfe4dc8608374bd6c64795d469.svg";
export { ForwardRef as ReactComponent };